import { render } from "./state.vue?vue&type=template&id=05671a6a&scoped=true"
import script from "./state.vue?vue&type=script&lang=js"
export * from "./state.vue?vue&type=script&lang=js"

import "./state.vue?vue&type=style&index=0&id=05671a6a&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05671a6a"]])

export default __exports__